import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/national-day/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/national-day',
  name: 'activity_national_day',
  component: Index,
  meta: {
    title: '奇迹探险之旅',
  },
}

export default [indexRoute]
